import React from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import LocalizedStrings from 'react-localization';
import { Segment, Input, Button, Dimmer, Loader, Container, Header, Image, Grid, List } from "semantic-ui-react";
import "./Profile.css";

//ONLY FOR DEV, NOT FOR PRODUCTION
//Bearer Token is refreshed every 84600 seconds according Auth)
axios.defaults.headers.common['Authorization'] = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlEwSTNPRGs1UlRNM01qWTFNek0xUTBOQ05USTROakZDTXpsQ1FrTkdRa05EUmtVNE16RkdNUSJ9.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.SVY4WmXrmm4fJxF82ZYylURqmbI2r08uPEwOmBSfCudg1Oh-9jkeIVG4GKSCObpsNJYH5Kh2GqiM6AcTfa1lF13yiRS9O4F2gc7rr77RIWJUhf_6X5rbvAtiD61JxpugDjGGqAPHsEhG5f68wvwARsCNbvqii5NS8EHwZnrSF1PO6jzz4FRJMlhOCzZ9IPQTLCuYrTMEkFOKWawPdfNQbDF-0X9J9RbQTnyhzW29XFOPE938c8Gpv3ylSQDA2e4g1HPbvb0jGwGbX1FKe3Qzxl2JwZlHeKMgND1VxcB9gqTaGJKu6mOhe9qXfYymfLvVk2hQMH6pylxEBb8LuAIKhw';
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      newNickname: '',
      newEmail: '',
      newLanguage: '',
      tempToken: '',
      newAccount_type_detail: '',
      loading: false,
      userInfo: {}
    }
  }

  strings = new LocalizedStrings({
    en:{
      header:"Your Profile",
      id:"ID",
      name:"Name",
      email:"Email",
      email_verified:"Email Verified",
      email_verified_yes:"YES",
      email_verified_no:"NO",
      role:"Role",
      ever_login: "Ever login",
      language: "Language",
      account_type: "Account Type",
      deviceId: "Device ID",
      token: "TOKEN",
      expires: "EXPIRES",
      edit_button: 'Edit',
      delete_button: 'Delete Account',
      save_button: 'Save',
      cancel_button: 'Cancel',
      notifySuccess: "Success! User info is received.",
      notifyProfileUpdate: "Success! Your Profile is updated.",
      notifyError: "Something went wrong!",
    },
    bg: {
      header:"Вашият профил",
      id:"Идентификационен номер",
      name:"Име",
      email:"Имейл",
      email_verified:"Потвърден имейл",
      email_verified_yes:"ДА",
      email_verified_no:"НЕ",
      role:"Роля",
      ever_login: "Предишно влизане",
      language: "Език",
      account_type: "Тип на акаунта",
      deviceId: "Иден. номер на устройство",
      token: "ТОКЕН",
      expires: "ВАЛИДЕН ДО",
      edit_button: 'Промяна',
      delete_button: 'Изтриване на акаунта',
      save_button: 'Запазване',
      cancel_button: 'Отказ',
      notifySuccess: "Успешно! Информацията за потребителя е получена.",
      notifyProfileUpdate: "Успешно! Профила е променен.",
      notifyError: "Нещо се обърка!",
    }
   });

  async getTempToken() {
    await axios.post('https://fc-demo.eu.auth0.com/oauth/token', {
      "grant_type": "client_credentials",
      "client_id": "m9NKG7ybBVDkN8oDGn91gFZDAXXVjana",
      "client_secret": "LFTgAp7Zh7NfJNIy6rSoiTYGPbZXZeoiYy0M0M7srhe0KUvjbzI89HnFliFc_59f",
      "audience": "https://fc-demo.eu.auth0.com/api/v2/",
    })
    .then(response => (this.setState({tempToken: response.data.access_token}), console.log('token: ', response.data.access_token)))
    .catch(err => {
      console.log(err);
      this.notifyError();
    });
  }

  async getUserInfo(deviceid, token) {
    await axios.get("https://demo.epay.bg/xdev/api/user/info", {
        params: {
            APPID: '2123128777047314469988321512492541281777074012414332339158786136',
            DEVICEID: '9i9q49QJJw6YG19MPjlDPBNyU0KaDH',
            TOKEN: '35319729688471428012946277912838',
            PINS: 1 //If you want information about the Payment Instruments
        }
    })
    .then(res => (this.setState({ userInfo: res.data }), this.notifySuccess(), console.log('res.data: ',res.data)))
    .catch(err => {
      console.log(err);
      this.notifyError();
    });
  }

  async updateUserInfo(userid, token) {
    console.log('tempToken: ',this.state.tempToken)
    await axios.patch(`https://fc-demo.eu.auth0.com/api/v2/users/${userid}`, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': "Bearer " + token,
      },
      "app_metadata": {
        "status": "OK"
      },
    })
    .then(this.setState({ edit: false, loading: false }))
    .then(res => res.status === 200 ? this.notifyProfileUpdate() : null)
    .catch(err => {
      console.log(err);
      this.notifyError();
    });
  }

  async updateUserInfo2(userid, token) {
    this.setState({ loading: true })
    console.log('tempToken: ',this.state.tempToken)
    await fetch(`https://fc-demo.eu.auth0.com/api/v2/users/${userid}`, {
      method: 'PATCH',
      headers: {
        'Authorization': "Bearer " + token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        nickname: this.state.newNickname,
        email: this.state.newEmail,
        user_metadata: {
          language: this.state.newLanguage
        }
      })
    })
    .then(res => res.status === 200 ? this.notifyProfileUpdate() : this.notifyError())
    .then(this.setState({ edit: false, loading: false }))
    .catch(err => {
      console.log(err);
      this.notifyError();
    });
  }

  notifySuccess = () => toast.success(this.strings.notifySuccess)
  notifyProfileUpdate = () => toast.info(this.strings.notifyProfileUpdate)
  notifyError = () => toast.error(this.strings.notifyError)

  _setLanguage = (lang) => {
    //console.log(lang)
    this.strings.setLanguage(lang)
  }

  render() {
    const { loading, userInfo } = this.state;
    return (
          <div className="profile-area" style={{ marginTop: "3%" }}>
          {this._setLanguage(this.props.user["https://fc-demo/language"])}
            <ToastContainer />
            <Dimmer active={loading} inverted>
              <Loader inverted content='Loading' />
            </Dimmer>
            <Segment style={{ borderWidth: "0px", boxShadow: "none" }}>
              <Container textAlign="center">
                <Header as="h2">{this.strings.header}</Header>
                <hr />
                <Grid divided="vertically">
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Image size="medium" src={this.props.user.picture} alt="profile" />
                    </Grid.Column>
                    <Grid.Column>
                      {this.state.edit ? 
                      (
                        <Segment raise textAlign='left'>
                          <List>
                            <List.Item header={this.strings.id} content={this.props.user.sub} />
                            <List.Item header={this.strings.name} content={<Input placeholder={this.props.user.nickname} onChange={e => this.setState({ newNickname: e.target.value })} />} />
                            <List.Item header={this.strings.email} content={<Input placeholder={this.props.user.email} onChange={e => this.setState({ newEmail: e.target.value })} />} />
                            <List.Item header={this.strings.role} content={this.props.user["https://fc-demo/role"]} />
                            <List.Item header={this.strings.ever_login} content={this.props.user["https://fc-demo/firstLogin"] ? 'true' : 'false'} />
                            <List.Item header={this.strings.language} content={<Input placeholder={this.props.user["https://fc-demo/language"]} onChange={e => this.setState({ newLanguage: e.target.value })} />} />
                            <List.Item header={this.strings.account_type} content={<Input placeholder={this.props.user["https://fc-demo/account_type_detail"]} onChange={e => this.setState({ newAccount_type_detail: e.target.value })} />} />
                            <List.Item header={this.strings.deviceId} content={this.props.user["https://fc-demo/deviceId"]} />
                            <List.Item header={this.strings.token} content={this.props.user["https://fc-demo/TOKEN"]} />
                            <List.Item header={this.strings.expires} content={this.props.user["https://fc-demo/EXPIRES"]} />
                          </List>
                            <Button primary onClick={() => this.updateUserInfo2(this.props.user.sub, this.state.tempToken)}>{this.strings.save_button}</Button>
                            <Button color="red" onClick={() => this.setState({ edit: false })}>{this.strings.cancel_button}</Button>
                            <p>THE CHANGES WILL APPEAR ON THE NEXT LOGIN</p>
                        </Segment>
                      )
                      : (
                          <Segment placeholder textAlign='left'>
                            <List>
                              <List.Item header={this.strings.id} content={this.props.user.sub} />
                              <List.Item header={this.strings.name} content={this.props.user.nickname} />
                              <List.Item header={this.strings.email} content={this.props.user.email} />
                              <List.Item header={this.strings.email_verified} content={this.props.user.email_verified ? this.strings.email_verified_yes : this.strings.email_verified_no} />
                              <List.Item header={this.strings.role} content={this.props.user["https://fc-demo/role"]} />
                              <List.Item header={this.strings.ever_login} content={this.props.user["https://fc-demo/firstLogin"] ? 'true' : 'false'} />
                              <List.Item header={this.strings.language} content={this.props.user["https://fc-demo/language"]} />
                              <List.Item header={this.strings.account_type} content={this.props.user["https://fc-demo/account_type_detail"]} />
                              <List.Item header={this.strings.deviceId} content={this.props.user["https://fc-demo/deviceId"]} />
                              <List.Item header={this.strings.token} content={this.props.user["https://fc-demo/TOKEN"]} />
                              <List.Item header={this.strings.expires} content={this.props.user["https://fc-demo/EXPIRES"]} />
                            </List>
                            <Button secondary onClick={() => (this.setState({ edit: true }), this.getTempToken())}>{this.strings.edit_button}</Button>
                          </Segment>
                        )
                      }
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                  <Button color='red' onClick={() => console.log('User asks fro deletion.')}>{this.strings.delete_button}</Button>
                          {/*  <div>
                            <p>User EpayBG data:</p>
                            <Button secondary disabled={this.props.user["https://fc-demo/TOKEN"] ? false : true} onClick={() => (this.getTempToken())}>Get User TOKEN</Button>
                          </div> */}
              </Container>
            </Segment>
          </div>
        )}
      
}

export default Profile;
